import { Card } from '../components/ui/cards'
import { Check, X, AlertTriangle } from "lucide-react";

export const DifferentiationTable = () => {
  const features = [
    {
      feature: "Remote Placement",
      foundat: { status: "yes", note: "No site visit needed" },
      traditional: { status: "no", note: "On-site scanning required" },
      digital: { status: "partial", note: "Requires existing 3D models" },
    },
    {
      feature: "Indoor/Outdoor Support",
      foundat: { status: "yes", note: "Works everywhere" },
      traditional: { status: "partial", note: "GPS-dependent" },
      digital: { status: "yes", note: "Model-dependent" },
    },
    {
      feature: "Time to Deploy",
      foundat: { status: "yes", note: "Hours to days" },
      traditional: { status: "no", note: "Weeks to months" },
      digital: { status: "partial", note: "Depends on model availability" },
    },
    {
      feature: "3D Model Requirement",
      foundat: { status: "yes", note: "Optional" },
      traditional: { status: "yes", note: "Created via scanning" },
      digital: { status: "no", note: "Mandatory" },
    },
    {
      feature: "Cost Structure",
      foundat: { status: "yes", note: "Subscription-based" },
      traditional: { status: "no", note: "High upfront scanning costs" },
      digital: { status: "partial", note: "Ongoing modeling costs" },
    },
  ];

  const getIcon = (status: string) => {
    switch (status) {
      case "yes":
        return <Check className="w-5 h-5 text-green-600" />;
      case "no":
        return <X className="w-5 h-5 text-red-600" />;
      case "partial":
        return <AlertTriangle className="w-5 h-5 text-amber-600" />;
      default:
        return null;
    }
  };

  return (
    <section className="py-20 bg-home-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-home-foreground mb-4">
            How FoundAt Compares
          </h2>
          <p className="text-lg text-home-muted-foreground max-w-2xl mx-auto">
            See how GO-Locate AR™ differs from traditional AR scanning and digital twin platforms
          </p>
        </div>

        <Card className="overflow-hidden border-2 border-home-primary/20 shadow-xl">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gradient-to-r from-home-primary/10 via-home-accent/10 to-home-primary/10">
                <tr>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-home-foreground">
                    Feature
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-semibold bg-gradient-to-r from-home-primary to-home-accent bg-clip-text text-transparent">
                    FoundAt GO-Locate AR™
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-semibold text-home-muted-foreground">
                    Traditional Scan-Based AR
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-semibold text-home-muted-foreground">
                    Digital Twin Platforms
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                {features.map((row, idx) => (
                  <tr key={idx} className="hover:bg-home-muted/30 transition-colors">
                    <td className="px-6 py-4 text-sm font-medium text-home-foreground">
                      {row.feature}
                    </td>
                    <td className="px-6 py-4 bg-home-primary/5">
                      <div className="flex flex-col items-center gap-1">
                        {getIcon(row.foundat.status)}
                        <span className="text-xs text-home-muted-foreground text-center">
                          {row.foundat.note}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex flex-col items-center gap-1">
                        {getIcon(row.traditional.status)}
                        <span className="text-xs text-home-muted-foreground text-center">
                          {row.traditional.note}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex flex-col items-center gap-1">
                        {getIcon(row.digital.status)}
                        <span className="text-xs text-home-muted-foreground text-center">
                          {row.digital.note}
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </section>
  );
};
